import { makeStyles, lighten, darken } from "@material-ui/core";

export const ProductSelectorStyle = makeStyles((theme) => ({
    root: {
        display: "flex",
        flexDirection: "column",
        flex: "1",
        fontFamily: "Nexa",
        margin: "15px",
        "& a": {
            color: "#c70101",
            textDecoration: "none",
            "&:hover": {
                textDecoration: "underline",
            },
        },
    },
}));
